// libs
import React from 'react';
// components
import LayoutPage from 'components/layoutPage/LayoutPage';
// utils
import useInstanceConfig from 'modules/siteConfig/hooks/useInstanceConfig';
import { GetStaticProps } from 'next';
import ErrorPage from 'next/error';
import { FAQPageJsonLd, NextSeo } from 'next-seo';
import striptags from 'striptags';
import { Site } from 'types/interfaces/SiteConfig';
import getStaticPathsSite from 'utils/getStaticPathsSite';

import { Box as MaterialBox, Container } from '@lyearn/ui';

const getFAQData = (faq: Site['faq']) => {
  return faq.map((faqItem) => {
    return {
      questionName: faqItem.question,
      acceptedAnswerText: striptags(faqItem.answer, [], ' '), // Removes all html tags
    };
  });
};

export default function FAQ() {
  const { site, pages } = useInstanceConfig();
  if (!pages.FAQ_PAGE_LAYOUT) return <ErrorPage statusCode={404} />;
  const { host, seo } = site;
  const { siteName, faq, twitterHandle, homepage } = seo;
  const url = `https://${host}/faq`;

  return (
    <>
      <MaterialBox>
        <Container component="main">
          <LayoutPage layoutConfig={pages.FAQ_PAGE_LAYOUT} />
        </Container>
      </MaterialBox>
      <NextSeo
        canonical={url}
        description={faq.description}
        openGraph={{
          title: 'FAQ',
          description: faq.description,
          site_name: siteName,
          type: 'website',
        }}
        title="FAQ"
        titleTemplate={`%s | ${homepage.title}`}
        twitter={{
          site: twitterHandle,
          cardType: 'summary_large_image',
        }}
      />
      <FAQPageJsonLd mainEntity={getFAQData(site.faq)} />
    </>
  );
}

export { getStaticPathsSite as getStaticPaths };

export const getStaticProps: GetStaticProps = async (context) => {
  return {
    props: {},
    revalidate: 180,
  };
};
